<template>
  <div class="wage-insurance-single__row">
    <HomeWageTooltip v-if="tooltip" location="top">
      <template #activator="{ props: tooltipProps }">
        <span
          v-bind="tooltipProps"
          class="wage-insurance-single__name wage-insurance-single__name--tooltip"
          :class="nameClass"
        >
          <slot name="label">{{ label }}</slot>
        </span>
      </template>
      <span style="white-space: pre-line">{{ tooltip }}</span>
    </HomeWageTooltip>
    <span v-else class="wage-insurance-single__name" :class="nameClass">
      <slot name="label">{{ label }}</slot>
    </span>
    <HomeWageTooltip location="top" member-visible>
      <template #activator="{ props: cbTip }">
        <input
          v-bind="cbTip"
          type="checkbox"
          class="wage-insurance-single__fix-cb wage-insurance-single__fix-cb--tooltip"
          :checked="fixed"
          :disabled="disabled"
          @change="emit('toggle-fixed', ($event.target as HTMLInputElement).checked)"
        />
      </template>
      <span style="white-space: pre-line">{{ fixCheckboxTooltip }}</span>
    </HomeWageTooltip>
    <input
      :id="inputId"
      type="text"
      class="wage-payroll-grid__input"
      :class="{
        'wage-payroll-grid__input--readonly': fixed && !disabled,
      }"
      :value="displayValue"
      :readonly="disabled || fixed"
      inputmode="numeric"
      @click="emit('input-click')"
      @focus="emit('input-focus', $event)"
      @input="emit('input', $event)"
      @blur="emit('blur')"
      @keydown.enter="($event.target as HTMLInputElement).blur()"
    />
  </div>
</template>

<script setup lang="ts">
import HomeWageTooltip from '@/components/wage/home/HomeWageTooltip.vue';
import { HOME_WAGE_DEDUCTION_FIX_CHECKBOX_TOOLTIP } from '@/policies';

withDefaults(
  defineProps<{
    label: string;
    tooltip?: string;
    fixed: boolean;
    displayValue: string;
    inputId: string;
    disabled?: boolean;
    nameClass?: string | Record<string, boolean>;
    fixCheckboxTooltip?: string;
  }>(),
  {
    fixCheckboxTooltip: HOME_WAGE_DEDUCTION_FIX_CHECKBOX_TOOLTIP,
  }
);

const emit = defineEmits<{
  'toggle-fixed': [checked: boolean];
  'input-click': [];
  'input-focus': [event: FocusEvent];
  input: [event: Event];
  blur: [];
}>();
</script>
